import { render } from "./NetworkSwitch.vue?vue&type=template&id=1b9d5941&scoped=true&ts=true"
import script from "./NetworkSwitch.vue?vue&type=script&lang=ts"
export * from "./NetworkSwitch.vue?vue&type=script&lang=ts"

import "./NetworkSwitch.vue?vue&type=style&index=0&id=1b9d5941&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9d5941"]])

export default __exports__